// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"73":"f2c78948","160":"69458c51","660":"e868ecd7","933":"83fab13f","972":"0e9e13bd"}[chunkId] + ".chunk.css";
};